// extracted by mini-css-extract-plugin
module.exports =  {"loadingWrapper":"loadingWrapper__drf25"};